import Component from "../../components/ChatSearchResultsPage/ChatSearchResultsPage";
import {useState, useEffect, useContext} from "preact/hooks";
import {searchMessages} from "../../api";
import {NavigationContext} from "../../contexts/NavigationContext";

const ChatSearchResultsPage = ({query = '', roomId}) => {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);
  const {route, navigate} = useContext(NavigationContext);

  useEffect(() => {
    if (query && roomId)
    fetchResults(query, roomId);
  }, [query, roomId]);

  const fetchResults = (query, roomId) => {
    setLoading(true);
    searchMessages(roomId, query).then(response => {
      const results = response.data.results;
      setLoading(false);
      setResults(results);
    }).catch(err => {
      alert("Ocorreu um erro ao pesquisar as mensagens.");
      throw new Error(err);
    });
  };

  const onNavigateToMessage = message => {
    console.log({message});
  };

  const onBack = () => {
    navigate({path: "/chat", params: route.params});
  };

  return <Component
    query={query}
    loading={loading}
    messages={results}
    onBack={onBack}
    onNavigateToMessage={onNavigateToMessage}
  />
};

export default ChatSearchResultsPage;



// WEBPACK FOOTER //
// ./containers/ChatSearchResultsPage/ChatSearchResultsPage.js